import React from "react";
import "./App.css";
import Page1 from "./Pages/Page1/Page1";
import Page2 from "./Pages/Page2/Page2";
import Page3 from "./Pages/Page3/Page3";
import Page4 from "./Pages/Page4/Page4";
import Page5 from "./Pages/Page5/Page5";
import Page6 from "./Pages/Page6/Page6";

function App() {
  return (
    <div className="App">
      {/* <div className="side-image">
        <img src={sideBack} alt="Side Background" />
      </div> */}
      {/* Main content shifts to the right */}
      <div className="app-sizer">

     
      <Page1 />
      <Page2 />
      <Page3 />
      <Page4 />
      <Page5 />
      <Page6 />
          <div class="shadows_"></div>
          <div className="paper_edge_"></div>
      </div>
    </div>
  );
}

export default App;
